module.exports = __webpack_public_path__ + "assets/Alpha.49a5e705cdf84a7afe7b252ba27a3d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Alpha.png
// module id = 828
// module chunks = 0